export default __webpack_public_path__ + "f7fc71e8480a3e6cce62880b8195175c.png";